const { ENDPOINTS } = require("@/config/endpoints")

const credlixBypass = ENDPOINTS.CREDLIX_BYPASS;


export const sendOTPForTermsheet = async (phoneNumber, gCaptchaToken) => {

    const data = {
        "otpRequestType": "PHONE",
        "otpType": "TERMSHEET",
        "phone": phoneNumber,
        "otpLength": 6
    };
    const body = {
        'urlType': 'otp_generate',
        'method': 'POST',
        'headers': {
            'Content-Type': 'application/json'
        },
        'data': data
    }
    const response = await fetch(credlixBypass, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'g-recaptcha-response': gCaptchaToken
        },
        body: JSON.stringify(body)
    });
    // debugger
    return response
}

export const verifyOTPForTermsheet = async (requestId, otp, gCaptchaToken) => {
    const data = {
        "otp": otp,
        "requestId": requestId
    }
    const body = {
        'urlType': 'otp_verify',
        'method': 'POST',
        'data': data
    }
    const response = await fetch(credlixBypass, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'g-recaptcha-response': gCaptchaToken
        },
        body: JSON.stringify(body)
    }
    );
    return response;
}

export const fetchIECDetails = async (iecCode, gCaptchaToken) => {
    const params = {
        "iecCode": iecCode
    }
    const body = {
        "urlType": "iec-detail",
        "method": "GET",
        "params": params
    };
    const response = await fetch(credlixBypass, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'g-recaptcha-response': gCaptchaToken
        },
        body: JSON.stringify(body)
    });
    return response;
}

export const searchBuyer = async (buyerName, gCaptchaToken, abortController) => {
    const signal = abortController.signal;
    const params = {
        "buyerNameSuggestion": buyerName
    }
    const body = {
        "urlType": "auto-suggest-buyer-list-kanban",
        "method": "GET",
        "params": params
    };
    try {
        const response = await fetch(credlixBypass, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'g-recaptcha-response': gCaptchaToken
            },
            body: JSON.stringify(body),
            signal: signal
        });
        return response;
    } catch (error) {
        // Handle error or check if it's an abort error
        if (error.name === 'AbortError') {
        } else {
            console.error('Request failed:', error);
        } 
    }
}

export const generateTermsheet = async (data, gCaptchaToken) => {
    const body = {
        "urlType": "generate-termsheet-new",
        "method": "POST",
        "data": data,
        "headers": {
            "Content-Type": "application/json",
            "accept": "application/pdf"
        }
    };
    const response = await fetch(credlixBypass, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'g-recaptcha-response': gCaptchaToken
        },
        body: JSON.stringify(body)
    }, { responseType: 'blob' });
    return response;
}

export const sendOTPForMexico = async (phoneNumber, gCaptchaToken, companyName, email) => {

    const data = {
        "otpRequestType": "EMAIL_WHATSAPP",
        "phone": phoneNumber,
        "recipientName":companyName,
        "email": email,
        "country": "Mexico",
        "otpLength": 6
    };
    const body = {
        'urlType': 'otp_generate',
        'method': 'POST',
        'headers': {
            'Content-Type': 'application/json'
        },
        'data': data
    }
    const response = await fetch(credlixBypass, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'g-recaptcha-response': gCaptchaToken
        },
        body: JSON.stringify(body)
    });
    return response
}

export const verifyOTPForMexico = async (requestId, otp, gCaptchaToken) => {
    const data = {
        "otp": otp,
        "requestId": requestId
    }
    const body = {
        'urlType': 'otp_verify',
        'method': 'POST',
        'data': data
    }
    const response = await fetch(credlixBypass, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'g-recaptcha-response': gCaptchaToken
        },
        body: JSON.stringify(body)
    }
    );
    return response;
}
